import { Typography, getTypographyDefaultColor, useMediaQuery } from '@ag1/ui';
import clsx from 'clsx';
import { TestimonialsV5 } from 'types/studio/studio';
import TestimonialsSliderArrows from '../TestimonialsSliderArrows/TestimonialsSliderArrows';
import { TestimonialsSliderArrowsProps } from '../TestimonialsSliderArrows/types';
import styles from './styles.module.scss';

type Props = Pick<
  TestimonialsV5,
  | 'headline'
  | 'isStyleVariant'
  | 'subtitle'
  | 'superHeadline'
  | 'bodyContent'
  | 'textAlignment'
  | 'theme'
  | 'clickable'
> &
  TestimonialsSliderArrowsProps & {
    sliderDesktopActive: boolean;
  };

const TestimonialsHeading = ({
  subtitle,
  superHeadline,
  headline,
  isStyleVariant,
  bodyContent,
  textAlignment,
  onScrollPrev,
  onScrollNext,
  sliderDesktopActive,
  theme,
  clickable
}: Props) => {
  const atSmall = useMediaQuery('s');
  const hasSliderDesktop = !clickable && sliderDesktopActive;
  return (
    <div
      className={clsx(
        isStyleVariant && styles.rootStyleVariant,
        hasSliderDesktop && styles.rootWithSlider,
        !isStyleVariant && !hasSliderDesktop && styles.root
      )}>
      <div>
        {subtitle && (
          <Typography
            component="p"
            variant="subtitle"
            size="1"
            weight="700"
            className={styles.subtitle}
            noPadding
            color={getTypographyDefaultColor(theme)}>
            {subtitle}
          </Typography>
        )}
        {superHeadline && (
          <Typography
            component="p"
            variant="subtitle"
            size="2"
            weight="400"
            className={styles.superHeadline}
            noPadding
            color={getTypographyDefaultColor(theme)}>
            {superHeadline}
          </Typography>
        )}
        {headline && (
          <Typography
            component="h2"
            variant="headlineSans"
            size="2"
            weight="400"
            className={clsx(
              styles.headline,
              isStyleVariant && styles.variantHeadline,
              !textAlignment?.alignMobileLeft && styles.centerHeadline
            )}
            noPadding
            color={getTypographyDefaultColor(theme)}>
            {headline}
          </Typography>
        )}
        {bodyContent && (
          <Typography
            component="p"
            variant="body"
            size="1"
            weight="400"
            className={clsx(
              textAlignment?.alignLeft && styles.leftDesktop,
              textAlignment?.alignMobileLeft && styles.leftMobile,
              isStyleVariant && styles.variantBodyContent
            )}
            noPadding
            color={getTypographyDefaultColor(theme)}>
            {bodyContent}
          </Typography>
        )}
      </div>
      {hasSliderDesktop && atSmall && (
        <div className={styles.buttons}>
          <TestimonialsSliderArrows
            onScrollPrev={onScrollPrev}
            onScrollNext={onScrollNext}
            theme={theme}
          />
        </div>
      )}
    </div>
  );
};

export default TestimonialsHeading;
